import { PayloadAction } from '@reduxjs/toolkit';
import createAppSlice from 'app/createAppSlice';
import type { Transaction } from './types';

interface TxmonTransactionsPagination {
  page: number;
  pageSize: number;
  total: number;
}

interface TxmonTransactionsState {
  transactions: Transaction[];
  pagination: TxmonTransactionsPagination;
  txmonTransactionsLoaded: boolean;
}

interface SetTransactionsPayload {
  transactions: Transaction[];
  page: number;
  pageSize: number;
  total: number;
}

const initialState: TxmonTransactionsState = {
  transactions: [],
  pagination: {
    page: 0,
    pageSize: 10,
    total: 0,
  },
  txmonTransactionsLoaded: false,
};

const txmonTransactionsSlice = createAppSlice({
  name: 'txmonTransactions',
  initialState,
  reducers: {
    setTxmonTransactions: (
      state,
      action: PayloadAction<SetTransactionsPayload>,
    ) => {
      const { transactions, page, pageSize, total } = action.payload;
      state.transactions = transactions;
      state.pagination = { page, pageSize, total };
      state.txmonTransactionsLoaded = true;
    },
    txmonTransactionsReset: () => initialState,
  },
});

export const { setTxmonTransactions, txmonTransactionsReset } =
  txmonTransactionsSlice.actions;
export default txmonTransactionsSlice.reducer;
